import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom"; 
import { Alert, Container, Box, Typography, TextField, Button, InputAdornment, IconButton, FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import PlumSvg from "../component/PlumSvg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { clientsAPI } from "../../Api";

const AddClient = () => {
  const [lastName, setlastName] = useState("");
  const [firstName, setfirstName] = useState("");
  const [market, setMarket] = useState("");
  const [proxy_ip, setProxyIp] = useState("");
  const [proxy_port, setProxyPort] = useState("");
  const [proxy_username, setProxyUsername] = useState("");
  const [proxy_password, setProxyPassword] = useState("");
  const [cookies, setCookies] = useState(""); // cookies как строка, можно преобразовать в объект при отправке
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    lastName: "",
    firstName: "",
    market: "",
    cookies: "",
    proxy_ip: "",
    proxy_port: "",
    proxy_username: "",
    proxy_password: ""
  });

  const AlertSuccess = () => (
    <Alert severity="success">
      Клиент создан!
    </Alert>
  );

  const AlertError = () => (
    <Alert severity="error">
      Ошибка создания клиента
    </Alert>
  );

  

  const validateForm = () => {
    const newErrors = {};

    if (!lastName) newErrors.lastName = "Фамилия обязателен";
    if (!firstName) newErrors.firstName = "Имя обязателен";
    if (!market) newErrors.market = "Маркет обязателен";
    if (!cookies) newErrors.cookies = "Cookies обязательны";
    if (!proxy_ip) newErrors.proxy_ip = "Прокси IP обязателен";
    if (!proxy_port) newErrors.proxy_port = "Прокси порт обязателен";
    if (!proxy_username) newErrors.proxy_username = "Прокси имя обязателено";
    if (!proxy_password) newErrors.proxy_password = "Прокси пароль обязателен";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        // cookies как строка, преобразуем в объект если возможно
        let cookiesObj;
        try {
          cookiesObj = JSON.parse(cookies);
        } catch (err) {
          cookiesObj = cookies; // если не JSON, отправим как есть
        }
        let data = await clientsAPI.createClient({ lastName, firstName, cookies: cookiesObj, proxy_ip, proxy_port, proxy_username, proxy_password, market });
        if (data.data.success) {
          setlastName("");
          setfirstName("");
          setMarket("")
          setCookies("");
          setProxyIp("");
          setProxyPort("");
          setProxyUsername("");
          setProxyPassword("");
          setAlert(<AlertSuccess />);
          navigate('/clients/list');
        } else {
          setAlert(<AlertError />);
        }
      } catch (e) {
        setAlert(<AlertError />);
      }
    }
  };

  return (
    <Container maxWidth="sx">
      <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: "#fefcfb" }}>
        <Typography variant="h5" align="center" gutterBottom>
          <PlumSvg /> Добавить клиента
        </Typography>
        
        {alert && <div>{alert}</div>} {/* Условный рендеринг Alert */}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Фамилия"
            variant="outlined"
            fullWidth
            margin="normal"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.lastName)}
            helperText={errors.lastName}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />

          <TextField
            label="Имя"
            variant="outlined"
            fullWidth
            margin="normal"
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.firstName)}
            helperText={errors.firstName}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
<FormControl
  fullWidth
  margin="normal"
  error={Boolean(errors.market)}
  sx={{
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": { borderColor: "#683d62" },
    },
    "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
    "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
  }}
>
  <InputLabel shrink>Маркет</InputLabel>
  <Select
    value={market}
    onChange={(e) => setMarket(e.target.value)}
    label="Маркет"
    displayEmpty
    notched
  >
    <MenuItem value=""><em>Выберите маркет</em></MenuItem>
    <MenuItem value="yandex">Яндекс Маркет</MenuItem>
    <MenuItem value="funpay">FunPay</MenuItem>
  </Select>
  <FormHelperText>{errors.market}</FormHelperText>
</FormControl>
          <TextField
            label="Cookies (JSON или строка)"
            variant="outlined"
            fullWidth
            margin="normal"
            value={cookies}
            onChange={(e) => setCookies(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.cookies)}
            helperText={errors.cookies}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
                   <TextField
            label="Прокси ИП"
            variant="outlined"
            fullWidth
            margin="normal"
            value={proxy_ip}
            onChange={(e) => setProxyIp(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.proxy_ip)}
            helperText={errors.proxy_ip}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
                    <TextField
            label="Прокси Порт"
            variant="outlined"
            fullWidth
            margin="normal"
            value={proxy_port}
            onChange={(e) => setProxyPort(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.proxy_port)}
            helperText={errors.proxy_port}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
                    <TextField
            label="Прокси Юзер"
            variant="outlined"
            fullWidth
            margin="normal"
            value={proxy_username}
            onChange={(e) => setProxyUsername(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.proxy_username)}
            helperText={errors.proxy_username}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />
            <TextField
            label="Прокси пароль"
            variant="outlined"
            fullWidth
            margin="normal"
            value={proxy_password}
            onChange={(e) => setProxyPassword(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.proxy_password)}
            helperText={errors.proxy_password}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": { borderColor: "#683d62" },
              },
              "& .MuiInputBase-input": { "&:focus": { color: "#683d62" } },
              "& .MuiInputLabel-root": { "&.Mui-focused": { color: "#683d62" } },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, backgroundColor: "#683d62" }}
          >
            Добавить клиента
          </Button>
        </form>
      </Box>
    </Container>
  );
};

// Функция для генерации случайного пароля
function generatePassword() {
  const length = 12;
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
  let password = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    password += charset[randomIndex];
  }
  return password;
}

export default AddClient;
